/** Cache-Bust: altes blaues Mark auf Geräten verwerfen. */
const MA_MARK_SRC = '/images/ma-mark.png?v=white1';

/** Verkürztes MA-Logo (Musik Akademie) — nur Companion. */
export default function MaMark({ className = 'w-8 h-8', alt = 'MA', testId = 'ma-mark' }) {
  return (
    <img
      src={MA_MARK_SRC}
      alt={alt}
      className={`object-contain bg-white ${className}`}
      data-testid={testId}
      draggable={false}
      style={{ backgroundColor: '#FFFFFF' }}
    />
  );
}
